<template>
  <div class="theme-swatch">
    <span
      :class="{ spectrum }"
      :style="spectrum ? null : { backgroundColor: theme.themeColor }"
    ></span>
    <span :style="{ backgroundColor: theme.bodyColor }"></span>
    <span :style="{ backgroundColor: theme.secondaryColor }"></span>
    <span :style="{ backgroundColor: theme.textColor }"></span>
  </div>
</template>

<script>
export default {
  name: "ThemeSwatch",
  props: {
    theme: {
      type: Object,
      required: true,
    },
    spectrum: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.theme-swatch {
  display: inline-flex;
  flex-shrink: 0;
  height: 32px;
  border: 1px solid #12263f;

  span {
    width: 20px;
    height: 30px;
  }

  .spectrum {
    background: linear-gradient(
      to bottom,
      #ff0000,
      #ffff00,
      #00ff00,
      #00ffff,
      #0000ff,
      #ff00ff,
      #ff0000
    );
  }
}
</style>
